import { HorizontalAlignType, PaletteColorType, TextStyleType } from "../constants";
import { BaseCategory } from "./BaseCategory";
import { SlideCategories } from "./CategoryController";
import { SlideModelBuilder } from "./SlideModelBuilder";

export class QuoteCategory extends BaseCategory {
    get name() {
        return "Quote";
    }

    get type() {
        return SlideCategories.QUOTE;
    }

    get icon() {
        return null;
    }

    get description() {
        return "The content contains a quote.";
    }

    get slideTypes() {
        return [];
    }

    getPrompt() {
        return `If the content contains a specific quote use that otherwise find a famous quote. If the author is specified, include their name.`;
    }

    getPromptSchema() {
        return {
            quote: "a quote",
            author: "optional - the author of the quote",
            image: "Provide a prompt for generating a 16:9 background image to use with the quote. The image should either be the author of the quote or a single subject or abstract concept related to the quote. There should be no text in the image."
        };
    }

    getSlideModels(model, options = {}) {
        let models = [
            this.buildQuote(model, true, "center", { fontColor: "primary" }, { filterBrightness: 0.33 }, options),
            this.buildQuote(model, false, "center", {}, {}, options),
            this.buildQuote(model, true, "right", {}, {}, options),
        ];

        return models;
    }

    buildQuote(model, showImage, headlinePosition, fontOptions = {}, imageOptions = {}, options = {}) {
        let builder = new SlideModelBuilder("headline2", model);
        const imagePrompt = model.image || model.slideImage?.prompt;

        let quoteTextStyle = model.quote.length > 100 ? TextStyleType.HEADING : TextStyleType.HEADLINE;

        let primary = {
            fullBleed: true,
            showGutter: false,
            headlinePosition: "center",
            text: {
                blocks: [
                    builder.createBlock(model.quote, quoteTextStyle, fontOptions),
                ]
            },
        };

        if (model.author && model.author.toLowerCase() != "unknown") {
            primary.text.blocks.push({ type: "divider", dividerWidth: "short" });
            primary.text.blocks.push(builder.createBlock(model.author, TextStyleType.CAPTION, fontOptions));
        }

        if (showImage && imagePrompt) {
            primary.backdropStyle = "white_box";
            primary.items = [{
                componentType: "TextAndImage",
                childElement: builder.createImage(imagePrompt, imageOptions, !model.image)
            }];
        } else {
            builder.setBackgroundColor(PaletteColorType.THEME);
        }

        if (headlinePosition) {
            primary.headlinePosition = headlinePosition;

            if (headlinePosition == "right") {
                primary.textAlign = HorizontalAlignType.LEFT;
                primary.textPosition = HorizontalAlignType.LEFT;
            }
        }

        builder.createPrimary(primary);

        if (options.citeSources) {
            builder.createSourcesAttribution(model.sources);
        }

        return builder.model;
    }
}
